<template>
  <b-modal id="plan-sign-modal"
           :title="$t('sign')"
           centered>
    <FileGroup filetype="pdf"
               :fid="`file-sign-${plan.id}`"
               v-model="file"/>
    <AutosizeTextArea v-model="comment"
                      :label="$t('comment')"/>
    <template #modal-footer="{ close }">
      <div class="modal-footer-buttons">
        <b-button class="cancel mr-3 d-inline-block align-middle"
                  variant="themed"
                  @click="close()">
          {{ $t('cancel') }}
        </b-button>
        <button @click="save"
                class="w-auto px-3 btn-themed align-middle btn-themed-squared">
          {{ file ? $t('save') : $t('sign_without_upload') }}
        </button>
      </div>
    </template>
    <!--    <div class="text-right mt-5">-->
    <!--      <a @click="hideModal" class="btn btn-themed btn-themed-outline btn-themed-squared">-->
    <!--        {{ $t('cancel') }}-->
    <!--      </a>-->
    <!--      <a @click="success" class="btn btn-themed btn-themed-squared ml-3">-->
    <!--        {{ $t('payment_accepted') }}-->
    <!--      </a>-->
    <!--    </div>-->
  </b-modal>
</template>

<script setup>
import { getCurrentInstance, ref } from 'vue'
import FileGroup from "@/components/form/FileGroup.vue"
import AutosizeTextArea from "@/components/form/AutosizeTextArea.vue"

defineProps({
  plan: {
    type: Object,
    required: true
  }
})

const instance = (getCurrentInstance())
const file = ref(null)
const comment = ref('')

const save = async () => {
  hideModal()
}

const hideModal = () => {
  const bvModal = instance?.ctx?._bv__modal
  bvModal?.hide('plan-sign-modal')
}
</script>
